import {useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {useEffect} from 'react';
import {Autoplay} from 'swiper/modules';
import {Alert} from 'react-bootstrap';

import listingStyles from '@styles/listing.module.scss';
import styles from '@styles/home/home.module.scss';
import HowItWork from '@components/dropAuction/common/howItWork';
import VideoPlayer from '@components/home/VideoPlayer';
import {useApp} from '@context/AppProvider';
import {api} from '@utils/api';
import AuctionItem from '@components/product/list/AuctionItem';

import 'swiper/css';
import 'swiper/css/autoplay';

import CustomButton from '../UI/CustomButton';

const HomePage = () => {
	const [products, setProducts] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const videoUrl = process.env.SITE_URL + '/video.mov';
	const handleClose = () => setShowModal(false);
	const handleShow = () => setShowModal(true);
	const {
		idb: {user, origin, session, currencyData, currency, isoCode},
	} = useApp();

	const loadAuctionData = async () => {
		if (!session) return;
		const res = await api(
			{
				url: '/auction',
				method: 'POST',
				data: {
					page: 1,
					limit: 8,
				},
			},
			session,
		);

		if (res.status) {
			setProducts(res.results);
		}
	};

	useEffect(() => {
		loadAuctionData();
	}, [session]);

	return (
		<div>
			<div className={styles.homePageLandingBrand}>
				<div className={styles.homePageLandingBrand__content}>
					<h1>Introducing a New and Fun Way To Shop.</h1>
					<div>
						<p>
							Drop Auctions are a unique reverse auction sales technology
							providing shoppers with a fun and engaging way to shop.
						</p>
						<p>
							Shoppers can access amazing deals on their favorite products by
							hanging on while the price drops in a fast paced auction
							environment. They place a bid when the price is right...before
							someone else beats them to it!
						</p>
					</div>
				</div>
				<div className={styles.homePageLandingBrand__video}>
					<VideoPlayer
						autoPlay={true}
						src={videoUrl}
						muted={true}
						playsInline={true}
					/>
				</div>
			</div>
			<div></div>
			<div className={styles.headingSectionOne}>
				<h1> Upcoming Auctions </h1>
			</div>
			<div className='container py-5 '>
				{products.length > 0 && (
					<Swiper
						slidesPerView={5}
						spaceBetween={20}
						loop={products.length >= 5}
						className='auction-swiper-container'
						speed={1000}
						autoplay={{
							delay: 2000,
							disableOnInteraction: false,
						}}
						modules={[Autoplay]}
						breakpoints={{
							320: {
								slidesPerView: 1,
								spaceBetween: 10,
							},
							576: {
								slidesPerView: 2,
								spaceBetween: 15,
							},
							768: {
								slidesPerView: 3,
								spaceBetween: 20,
							},
							1024: {
								slidesPerView: 4,
								spaceBetween: 20,
							},
							1440: {
								slidesPerView: 5,
								spaceBetween: 20,
							},
						}}
					>
						{products.slice(0, 8).map(p => (
							<SwiperSlide key={p._id}>
								<AuctionItem data={p} styles={listingStyles} onSlider={true} />
							</SwiperSlide>
						))}
					</Swiper>
				)}
				{products.length === 0 && (
					<div className='row noFoundBlock'>
						<div className='col-md-12 text-center'>
							<Alert variant='danger' className='text-danger p-5'>
								<Alert.Heading className='text-danger'>
									Sorry, No Auctions Found!
								</Alert.Heading>
							</Alert>
						</div>
					</div>
				)}
				{products.length > 0 && (
					<div className='d-flex'>
						<CustomButton
							href='/drop-auctions/all'
							className={styles.btnCustom}
						>
							See All Auctions
						</CustomButton>
					</div>
				)}
			</div>
			<div className={styles.headingSectionTwo} id='how-it-works'>
				<h1>How It Works For Shoppers</h1>
			</div>
			<HowItWork />
			<div className={styles.headingSectionThree}>
				<div className={styles.headingSectionThree__TextContainer}>
					<p>
						Shoppers commit up front that if they purchase the item if they win.
						They don't know how low price will drop, nor how many people are in
						the auction room. This creates a sense of urgency to get a bid in
						before some else does!
					</p>
				</div>
			</div>
		</div>
	);
};

export default HomePage;
